var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccordion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 70,
    height: 53,
    viewBox: "0 0 70 53",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_7147",
    "data-name": "Groupe 7147",
    transform: "translate(-123.454 -831)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_685",
    "data-name": "Rectangle 685",
    width: 70,
    height: 8,
    rx: 1,
    transform: "translate(193.454 839) rotate(180)",
    fill: "#717171"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygone_10",
    "data-name": "Polygone 10",
    d: "M2,0,4,2H0Z",
    transform: "translate(188.454 836) rotate(180)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_686",
    "data-name": "Rectangle 686",
    width: 70,
    height: 8,
    rx: 1,
    transform: "translate(193.454 884) rotate(180)",
    fill: "#717171"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygone_11",
    "data-name": "Polygone 11",
    d: "M2,0,4,2H0Z",
    transform: "translate(188.454 881) rotate(180)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_7148",
    "data-name": "Groupe 7148",
    transform: "translate(123 840)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_683",
    "data-name": "Rectangle 683",
    d: "M1,0H69a1,1,0,0,1,1,1V8a0,0,0,0,1,0,0H0A0,0,0,0,1,0,8V1A1,1,0,0,1,1,0Z",
    transform: "translate(0.454)",
    fill: "#717171"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygone_9",
    "data-name": "Polygone 9",
    d: "M2,0,4,2H0Z",
    transform: "translate(61.454 3)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_684",
    "data-name": "Rectangle 684",
    transform: "translate(0.454 7)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 28,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 69,
    height: 27,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Ligne_33",
    "data-name": "Ligne 33",
    d: "M54.015.5H-.108A.456.456,0,0,1-.5,0,.456.456,0,0,1-.108-.5H54.015a.456.456,0,0,1,.392.5A.456.456,0,0,1,54.015.5Z",
    transform: "translate(5.5 13.5)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ligne_34",
    "data-name": "Ligne 34",
    d: "M46.015.5H-.108A.456.456,0,0,1-.5,0,.456.456,0,0,1-.108-.5H46.015a.456.456,0,0,1,.392.5A.456.456,0,0,1,46.015.5Z",
    transform: "translate(5.5 17.5)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ligne_35",
    "data-name": "Ligne 35",
    d: "M36,.5H0A.5.5,0,0,1-.5,0,.5.5,0,0,1,0-.5H36a.5.5,0,0,1,.5.5A.5.5,0,0,1,36,.5Z",
    transform: "translate(5.5 21.5)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ligne_36",
    "data-name": "Ligne 36",
    d: "M54.015.5H-.108A.456.456,0,0,1-.5,0,.456.456,0,0,1-.108-.5H54.015a.456.456,0,0,1,.392.5A.456.456,0,0,1,54.015.5Z",
    transform: "translate(5.5 26.5)",
    fill: "#707070"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccordion);
export default __webpack_public_path__ + "static/media/accordion.48d0603b360acfe436871f42037a91d6.svg";
export { ForwardRef as ReactComponent };